/** 
 *  ==========================
 *  BLOCK: Hero Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { HeaderIcon } from '~cartzillagb/icons'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { createButtonAttributes } from '~cartzillagb/util'

/**
 * External dependencies
 */
import { 
    disabledBlocks, i18n, pluginAssetsURL
} from 'cartzillagb'

export const schema = {
    enableContainer: {
        type: 'boolean',
        default: true
    },
    enableTitle: {
        type: 'boolean',
        default: true
    },
    enablesubTitle: {
        type: 'boolean',
        default: true
    },
    enableCategory: {
        type: 'boolean',
        default: true
    },
    
    title: {
        type: 'string',
    },
    subCategory1: {
        type: 'string',  
    },
    subCategory2: {
        type: 'string',  
    },
    subCategory3: {
        type: 'string',  
    },
    subCategory4: {
        type: 'string',  
    },
    subCategory5: {
        type: 'string',  
    },
    subCategory6: {
        type: 'string',  
    },
    subCategory7: {
        type: 'string',  
    },
    subCategory8: {
        type: 'string',  
    },
    subCategory9: {
        type: 'string',  
    },
    subTitle: {
        type: 'string',
    },
    backgroundImageURL: {
        type: 'string',
        // default: `${ pluginAssetsURL }img/hero-slider/img7.jpg`,
    },
    backgroundColor: {
        type: 'string',
    },
    background: {
        type: 'string',
        default: 'bg-accent',
    },
    enableForm: {
        type: 'boolean',
        default: true
    },

    align: {
        type: 'string',
        default: 'align-center'
    },

    design: {
        type: 'string',
        default: 'style-1',
    },

    enableButton: {
        type: 'boolean',
        default: false,
    },
    
    

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'View Demos',
        isShadow: true,
        defaultIcon: 'czi-arrow-down-circle',
        iconAfterText: true,
        defaultSize: 'lg' } ),
}

export const name = 'czgb/hero-block'

export const settings = {
    title: __( 'Hero Block', i18n ),
    description: __( 'A large hero area. Typically used at the very top of a page.', i18n ),
    icon: HeaderIcon,
    category: 'cartzillagb',
    example: {
        innerBlocks: [ { name: 'czgb/hero-search-form' } ],
    },
    keywords: [
        __( 'Hero Block', i18n ),
        __( 'Cartzillagb', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}